import { IconProp } from "@fortawesome/fontawesome-svg-core";

export const enum RequestState {
  Waiting, // 入力等変更前の待機
  Pending, // 入力等変更後、保存等の処理の前の待機
  Doing, // 処理中
  Success,
  Failed,
}

export const genNotificationColor = (requestState: RequestState) => {
  switch (requestState) {
    case RequestState.Pending:
    case RequestState.Failed:
      return "#fe493d";
    case RequestState.Doing:
      return "#f79b00";
    case RequestState.Success:
      return "#27c900";
    default:
      return "";
  }
};

export const genNotificationMessage = (requestState: RequestState) => {
  switch (requestState) {
    case RequestState.Pending:
      return "保存していない変更があります";
    case RequestState.Doing:
      return "通信中です";
    case RequestState.Success:
      return "保存が完了しました";
    case RequestState.Failed:
      return "保存に失敗しました";
    default:
      return "";
  }
};

export const genNotificationIcon = (
  requestState: RequestState
): IconProp | undefined => {
  switch (requestState) {
    case RequestState.Pending:
    case RequestState.Failed:
      return ["fal", "exclamation-circle"];
    case RequestState.Success:
      return ["fal", "check-circle"];
    default:
      return undefined;
  }
};
